/**
 * @generated SignedSource<<b4b93cde0853e4ca84b9a8ec6afa1f89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ReenablePaywallInput = {
  clientMutationId?: string | null;
  rootId: string;
  userId: string;
};
export type reenablePaywallButton_ReenablePaywallMutation$variables = {
  input: ReenablePaywallInput;
};
export type reenablePaywallButton_ReenablePaywallMutation$data = {
  readonly Admin: {
    readonly LearnProgress: {
      readonly reenablePaywall: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type reenablePaywallButton_ReenablePaywallMutation = {
  response: reenablePaywallButton_ReenablePaywallMutation$data;
  variables: reenablePaywallButton_ReenablePaywallMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnProgressAdminMutationSchema",
        "kind": "LinkedField",
        "name": "LearnProgress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "ReenablePaywallPayload",
            "kind": "LinkedField",
            "name": "reenablePaywall",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "reenablePaywallButton_ReenablePaywallMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "reenablePaywallButton_ReenablePaywallMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "da45d87dad3fcb11b139a8eb14a46177",
    "id": null,
    "metadata": {},
    "name": "reenablePaywallButton_ReenablePaywallMutation",
    "operationKind": "mutation",
    "text": "mutation reenablePaywallButton_ReenablePaywallMutation(\n  $input: ReenablePaywallInput!\n) {\n  Admin {\n    LearnProgress {\n      reenablePaywall(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "99474f4b5e588f3062bb6a23a674b19a";

export default node;
